import $ from 'jquery'

$(document).ready(function () {
  $('ul > li').each(function () {
    const $li = $(this)
    const $subMenu = $li.children('ul')

    if ($subMenu.length) {
      // Ajout de l'icône
      const $icon = $('<i class="vn-icons-close"></i>')
      $li.prepend($icon)

      // Gestionnaire de clic pour le premier niveau <li>
      $li.on('click', function (e) {
        e.stopPropagation()

        // Masquer tous les autres sous-menus des <li> frères
        $li.siblings().each(function () {
          $(this).children('ul').css('display', 'none')
          $(this).find('i.vn-icons-close').removeClass('rotate color')
          $(this).find('a').removeClass('color')
        })

        // Basculer l'affichage du sous-menu de l'élément cliqué
        $subMenu.css(
          'display',
          $subMenu.css('display') === 'flex' ? 'none' : 'flex'
        )

        $icon.toggleClass('rotate')
        $li.find('i').toggleClass('color')
        $li.find('a').toggleClass('color')
      })
    }
  })
})
